var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.999,
    height: 50,
    viewBox: "0 0 49.999 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5456",
    "data-name": "Group 5456",
    transform: "translate(-500 -360)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info-circle-Filled_1_",
    d: "M374,2555a25,25,0,1,0,25,25A25.042,25.042,0,0,0,374,2555Z",
    transform: "translate(151 -2195)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-circle-Filled_1_2",
    "data-name": "info-circle-Filled_1_",
    d: "M366.034,2555a17.035,17.035,0,1,0,17.034,17.035A17.063,17.063,0,0,0,366.034,2555Z",
    transform: "translate(158.966 -2187.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-circle-Filled_1_3",
    "data-name": "info-circle-Filled_1_",
    d: "M374,2555a25,25,0,1,0,25,25A25.041,25.041,0,0,0,374,2555Zm2.5,35a2.5,2.5,0,0,1-5,0v-10a2.5,2.5,0,1,1,5,0Zm-2.5-17.5a2.5,2.5,0,1,1,2.5-2.5A2.508,2.508,0,0,1,374,2572.5Z",
    transform: "translate(151.002 -2194.999)",
    fill: "#e23744"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/aboutUs.7dccb36a09b1f5694c3506297c845375.svg";
export { ForwardRef as ReactComponent };